import type { AskAiBody } from 'bindings/ai/AskAiBody';
import { Cookies } from 'react-cookie';
import { URL_FOUNDATION } from '../../config/keys';



export async function askToAi(body: AskAiBody): Promise<ReadableStream<Uint8Array>> {
	const cookies = new Cookies();
	const bearerToken: string | null = cookies.get('id_token') || null;
	const response = await fetch(`${URL_FOUNDATION}/api/v2/ai/ask`, {
		method: 'POST',
		headers: {
			'Authorization': bearerToken ?? '',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(body)
	});
	if (response.status == 402) {
		throw response.status;
	}

	if (!response.body) {
		throw new Error('No response body available for streaming');
	}
	return response.body;
}
